import {AxiosError} from 'axios'
import {GeneralError} from '51trips-frontend-core'
import {MessageErrorDTO} from '../domain/entities/AgencyUser.ts'

export type ParsedBackendError = {
    // Present only for a 400 field-validation response: a flat { field: message } map.
    fieldErrors?: Record<string, string>
    // A message safe to show as a generic/toast error — from MessageErrorDTO on
    // 401/404/500, or a fallback for anything else (network failure, etc).
    message: string
    errorKey?: string
}

// The two backend error shapes this API can return: MessageErrorDTO
// ({errorKey, message, params}) for auth/not-found/internal errors, or a flat
// {field: message} map for 400 body-validation errors — distinguished by
// status code and by the presence of `errorKey`, per the API spec.
export function parseBackendError(error: unknown, fallbackMessage: string): ParsedBackendError {
    const underlying = error instanceof GeneralError ? error.underlyingError : error
    const axiosError = underlying as AxiosError<unknown> | undefined
    const status = axiosError?.response?.status
    const data = axiosError?.response?.data

    if (status === 400 && data && typeof data === 'object' && !('errorKey' in data)) {
        return {fieldErrors: data as Record<string, string>, message: fallbackMessage}
    }

    if (data && typeof data === 'object' && 'errorKey' in data) {
        const dto = data as MessageErrorDTO
        return {message: dto.message || fallbackMessage, errorKey: dto.errorKey}
    }

    return {message: fallbackMessage}
}
